import { APP_PATHS } from 'src/app/app.paths';

export const PRINT_PATHS = {
  PRINT_CALENDAR: 'calendar',
};

export const PRINT_PATHS_ABSOLUTE = {
  PRINT_CALENDAR: `${APP_PATHS.PRINT}/${PRINT_PATHS.PRINT_CALENDAR}`,
};
